var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.tx ? _c('section', {
    staticClass: "utxo"
  }, [_c('article', {
    staticClass: "card meta"
  }, [_c('h3', {
    staticClass: "label"
  }, [_vm._v(" " + _vm._s(_vm._f("qualifyInput")(_vm._f("pluralizeWithoutCount")(_vm.inputs.length, 'Input'), _vm.tx.type)) + " "), _c('span', {
    staticClass: "utxo_count"
  }, [_vm._v(_vm._s(_vm.inputs.length))])]), _vm.inputs.length > 0 ? _c('div', _vm._l(_vm.inputs, function (input, i) {
    return _c('UtxoRowInput', {
      key: i,
      attrs: {
        "txtype": _vm.tx.type,
        "utxo": input
      }
    });
  }), 1) : _c('div', [_c('p', [_vm._v(" No input UTXOs found for this transaction on the Avalanche Explorer. ")])])]), _c('article', {
    staticClass: "card meta"
  }, [_c('h3', {
    staticClass: "label"
  }, [_vm._v(" " + _vm._s(_vm._f("qualifyOutput")(_vm._f("pluralizeWithoutCount")(_vm.outputs.length, 'Output'), _vm.tx.type)) + " "), _c('span', {
    staticClass: "utxo_count"
  }, [_vm._v(_vm._s(_vm.outputs.length))])]), _vm.tx.outputs.length > 0 ? _c('div', _vm._l(_vm.outputs, function (output, i) {
    return _c('UtxoRowOutput', {
      key: i,
      attrs: {
        "utxo": output,
        "txtype": _vm.tx.type,
        "type": "output"
      }
    });
  }), 1) : _c('div', [_c('p', [_vm._v("No output utxos found for this transaction.")])])])]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }